export interface ICarInfo {
  contacts: Contact[]
  id: number
  ins_info: InsInfo
  model_desc: string
  plate_number: string
  service_consultant_name: string
  solicit_info: SolicitInfo
  em_addition_info: EmAdditionInfo
  coupons_info: CouponsInfo
  vin: string
}

export interface Contact {
  id: number
  mobile_number: string
  name: string
}

export interface InsInfo {
  business_ins_expires_on: string
  employee: string
  force_ins_expires_on: string
  id: number
  insurance_company_name: string
  insurance_rating: string
  last_follow: LastFollow
  policy_type: PolicyType
}

export interface LastFollow {
  content: string
  date: string
  next_follow_date: string
}

export interface PolicyType {
  ins_items: any[]
  is_select_force: boolean
}

export interface SolicitInfo {
  customer_tag_names: string[]
  customer_type_name: string
  id: number
  last_enter_workshop_date: string
  last_follow_record: LastFollowRecord
  maintain_expired_date: string
  mileage: null | number
  next_maintain_date: null | string
  free_ins_left_count: null | number
  maintain_period: null | number
}

export interface LastFollowRecord {
  date: string
  next_follow_date: string
  recorder: string
  remarks: string
  type: string
}

export interface CouponsInfo {
  stats: Stats
  details: Detail[]
}

export interface Stats {
  total_coupons: number
  total_coupon_packages: number
  total_gift_cards: number
}

export enum CouponTypes {
  COUPON = 'coupon',
  GIFT_CARD = 'gift_card',
  COUPON_PACKAGE = 'coupon_package',
  STICKY = 'sticky'
}

export interface Detail {
  batch_name: string
  count: number
  earliest_expire_time: string
  type: CouponTypes
}

export interface EmAdditionInfo {
  submit_time: string
  service_consultant_id: number
  service_consultant_name: string
  not_consumed_items: NotConsumedItem[]
}

export interface NotConsumedItem {
  id: number
  name: string
  suggested_repair_time: string
  not_consumed_reason: string
  not_consumed_note: string
}
